<template>
  <div class="index">
    <!-- 永久免签APP安装教程 -->
    <div class="ios">
      <div class="return"><span @click="$router.history.go(-1)">返回</span><span><a @click="down('https://ios.tkls365.com/bfxIW6')" >下载</a></span></div>
      <div class="title">永久免签APP安装教程</div>
      <div class="title1">Installation tutorial</div>
      <div class="down-img">
        <img src="../../static/ios/coder1.png" alt="二维码">
      </div>
      <div class="down">
        <a @click="down('https://ios.tkls365.com/bfxIW6')" class="signature">
          <img src="../../static/ios/ipone.png" alt="图标">
          <span>永久免签APP下载</span>
        </a>
        <div class="Tutorial">
          <img src="../../static/ios/left0.png" alt="图标">
          <a href="https://www.wb99bz.com:8989">不想下载? 立即开始游戏</a>
          <img src="../../static/ios/left0.png" alt="图标">
        </div>
      </div>
      <img class="footer" src="../../static/ios/Tutorial.png" alt="安装教程">
    </div>
    <!-- 弹出框提示 -->
    <div class="Safari" v-if="ispop" >
      <div class="maskShow" @click="ispop=!ispop"></div>
      <div class="main">
        <div class="row main-text">
          <div><img src="../../static/ios/safari.png" alt=""></div>
          <div>
            <span>该链接只支持<font class="red">Safari</font>,请在<font class="red">Safari</font>中打开</span>
            <img class="return1" src="../../static/ios/fasle.png" alt="" @click.stop="ispop=!ispop">
          </div>
        </div>
        <div>
          <div class="main-url row">
            <span ref="text">https://www.getappwb01.xyz/</span>
            <span @click="fn()">复制</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      ispop:false,
      isweixin:false
    }
  },
  created(){
   
  },
  methods:{   
    //点击下载函数
    down(url){
      let ua = navigator.userAgent.toLowerCase();
      //判断是不是在iPhone的Safair浏览器打开的本页面
      if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) 
      {
        window.location.href=url;
      }else if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        this.isweixin = true
      }else{
        this.ispop = true;
      }
    },
    //复制
    fn(){
      var u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|iPad);?/i)) { 
          let range = document.createRange();
          // 选中需要复制的节点
          range.selectNode(this.$refs.text);
          // 执行选中元素
          window.getSelection().addRange(range);
          // 执行 copy 操作
          let successful = document.execCommand('copy');
          try {
              let msg = successful ? 'successful' : 'unsuccessful';
              alert('链接复制成功，快去打开吧~')
              this.ispop=false
          } catch (err) {
              console.log('Oops, unable to copy');
          }
          // 移除选中的元素
          window.getSelection().removeAllRanges();
      }
    }
  }
}
</script>

<style scoped>
 
 .return{background:linear-gradient(to top,#323335,#53565e);width:100%;height: 50px;line-height: 50px;position: fixed;top: 0;}
  .return span:first-child{
    color: #fff;
    display: inline-block;
    height: 30px;
    left: 1%;
    line-height: 30px;
    padding: 0 0px 0 34px;
    background: url(../../static/ios/return.png);
    background-size: 24px;
    background-position: 6px center;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    transform: translate(0px, -50%);
  }
  .return span:last-child{
    display: inline-block;
    height: 30px;
    line-height: 30px;
    right: 2%;
    padding: 0 0px 0 37px;
    background: url(../../static/ios/ipone.png);
    background-size: 22px;
    background-position: 10px 0;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    transform: translate(0px, -50%);
  }
  .return span:last-child a{color: #fff;}
  .title{color: #000;font-weight: bold;font-size: 1.3rem;letter-spacing: 1px;margin-top: 20%;}
  .title1{color: #ddddde;font-weight: bold;font-size: .8rem;letter-spacing: 1px;margin: .3rem 0}
  .down-img img{width: 40%;}
  .down{margin: 1.5rem 0}
  .down span,.down img{display: inline-block;}
  .down .signature{
    display: block;
    width: 92%;
    height: 2.4rem;
    line-height: 2.4rem;
    font-size: 1.1rem;
    background: linear-gradient(to top,#323335,#53565e);
    margin: 1% auto;
    color: #fff;
    border-radius: 5px;
  }
  .down .signature img:first-child {width: 16px;vertical-align: middle;margin-top: -5px;margin-right: 2px;}
  .signature img{width: 45px;vertical-align: middle;margin-top: -4px;margin-left: 2px;}
  .Tutorial a{color: #000;text-decoration: underline;font-size: .98rem}
  .Tutorial img{width: 13px;vertical-align: middle;margin-top: -1px;}
  .Tutorial img:first-child{transform:rotate(180deg);}
  .footer{width: 92%}
  /* iPad */
@media (min-width: 768px){
  .return{height: 90px;}
  .return span:first-child{
    height: 60px;
    line-height: 60px;
    padding: 0 0px 0 54px;
    background-size: 40px;
  }
  .return span:last-child{
    height: 60px;
    line-height: 60px;
    padding: 0 0px 0 54px;
    background-size: 36px;
    background-position: 10px 5px;
  }
  .footer{width: 70%}
  .return span{font-size: 2rem;}
  .title{font-size: 3rem;}
  .title1{font-size: 1.5rem}
  .down-img img{width: 35%;}
  .down .signature{height: 4rem;line-height: 4rem;font-size: 1.9rem;width: 70%}
  .down .signature img:first-child{width: 24px;}
  .Tutorial a{font-size: 1.5rem}
  .Tutorial img{width: 23px;margin-top: -8px;}
}
</style>



// WEBPACK FOOTER //
// src/components/signature.vue